/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  GET_PROVISIONAL_POLICY: {
    size: 10,
    skip: 0,
    where: [],
  },
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.platium-boilerplate.provisionalPage.provisionalPolicy',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'GET_PROVISIONAL_POLICY' },
      },
    },
    GET_PROVISIONAL_POLICY: {
      invoke: {
        id: 'provisionalPolicy',
        src: 'provisionalPolicy',
        onDone: {
          target: 'RENDER_PROVISIONAL_POLICY',
          actions: ['successAction'],
        },
        onError: {
          target: 'RENDER_PROVISIONAL_POLICY_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    RENDER_PROVISIONAL_POLICY: {
      on: {
        TRIGGER_REFRESH: {
          target: 'GET_PROVISIONAL_POLICY',
        },
      },
    },
    RENDER_PROVISIONAL_POLICY_ERROR: {
      type: 'final',
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
